import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import DSSegmentedTabs from "views/system-design/DSSegmentedTabs";

type OffHoursChoice = "always" | "work-hours";

interface OffHoursAlertingPickerProps {
  value: boolean;
  onChange: (alertOutsideWorkHours: boolean) => void;
}

const OffHoursAlertingPicker = ({
  value,
  onChange,
}: OffHoursAlertingPickerProps) => (
  <DSBox sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
    <DSTypography variant="caption" color="text.secondary">
      Alert outside working hours?
    </DSTypography>
    <DSSegmentedTabs<OffHoursChoice>
      size="small"
      value={value ? "always" : "work-hours"}
      onChange={(choice) => {
        if (choice) onChange(choice === "always");
      }}
      options={[
        { label: "Yes, alert anytime", value: "always" },
        { label: "No, wait for working hours", value: "work-hours" },
      ]}
    />
    <DSTypography variant="caption" color="text.secondary">
      {value
        ? "Alerts go out as soon as the incident happens, day or night."
        : "Incidents outside Sun–Thu 09:00–19:00 (Israel) alert on the first monitor run in working hours, if still open."}
    </DSTypography>
  </DSBox>
);

export default OffHoursAlertingPicker;
